module.exports = __webpack_public_path__ + "static/tim-gerend-speaking-publicly-mobile.e6199c42.webp";